import { useEffect } from 'react';
import SiteLayout from '../components/SiteLayout';
import { useRouter } from 'next/router';

import { withBreakpoints, Box, Spinner } from '../components/Boneyard';
import { withValue } from '@g4/automation-hooks';
import { LOOKUP_PAGE } from '../../automationHooks.json';

const Lookup = () => {
  const { query } = useRouter();

  const {
    flnc,
    FL_dair,
    FL_aair,
    adu,
    chAg,
    numChildren,
    chDb,
    FL_1_ddte,
    FL_2_ddte,
    // params not currently handled
    dlSource,
    search_type,
    FL_1_arlc,
    FL_1_flnm,
    FL_2_arlc,
    FL_2_flnm,
    promo,
    search_cartype,
    search_room,
    // marketing campaign variables
    utm_source,
    utm_medium,
    utm_content,
    utm_campaign,
  } = query;

  const formatStringDate = stringDate =>
    typeof stringDate === 'string' &&
    `${stringDate.substring(4)}-${stringDate.substring(
      0,
      2
    )}-${stringDate.substring(2, 4)}`;

  // this will work only for kayak which sends and array of ages for
  // Children 2-11 && Toddler in own seat under 2
  //
  // For example if you choose 1 child (age 2-11) & 2 toddlers (age < 2) in own seat
  // Kayak will send an query param  ch=8,8,11
  // meaning 2 toddlers in own seat (the two 8s) & 1 child
  const getKids = childrenAges => {
    const kids = childrenAges?.split(',');
    let tc = 0,
      tis = 0;

    for (let i = 0; i <= kids?.length; i += 1) {
      if (kids[i] === '8') {
        tis += 1;
      }
      if (kids[i] === '11') {
        tc += 1;
      }
    }
    return {
      tc,
      tis,
    };
  };

  const mapQueryParams = {
    // trip type
    tt: flnc === '1' ? 'ONEWAY' : flnc === '2' ? 'ROUNDTRIP' : '',
    // origin
    o: FL_dair,
    // destination
    d: FL_aair,
    // Travelers: Adults - For kayak youths are added to the adults number
    ta: adu,
    // Travelers: Children
    // Travelers: Infants in seat
    ...getKids(chAg),
    // Start date
    ds: formatStringDate(FL_1_ddte),
    // End date
    de: formatStringDate(FL_2_ddte),
    // params not currently handled
    dlSource,
    search_type,
    FL_1_arlc,
    FL_1_flnm,
    FL_2_arlc,
    FL_2_flnm,
    promo,
    search_cartype,
    search_room,
    numChildren,
    chDb,
    // marketing campaign variables
    utm_source,
    utm_medium,
    utm_content,
    utm_campaign,
  };

  const searchResultsPath = '/booking/flights';
  const queryStringParams = Object.keys(mapQueryParams).map(
    param =>
      mapQueryParams[param] !== undefined && `${param}=${mapQueryParams[param]}`
  );

  const queryString =
    '?' +
    queryStringParams.reduce((accumulator, currentValue) => {
      if (currentValue && currentValue !== false) {
        return accumulator + '&' + currentValue;
      }
      return accumulator;
    });

  useEffect(() => {
    window.location.href = searchResultsPath + queryString;
  }, [queryString]);

  return (
    <SiteLayout title="lookup">
      <Box w="100vw" h="50vh" d="flex" justifyContent="center">
        <Spinner
          size="large"
          inline
          automationHook={withValue(LOOKUP_PAGE.hook, 'spinner')}
        />
      </Box>
    </SiteLayout>
  );
};

export default withBreakpoints(Lookup);
